export default {
  user: {
    Name: 'Name',
    UnitName: 'Unit Name',
    UnitId: 'Unit Id',
    WechatNo: 'Wechat No',
    UserType: 'User Type',
    EffectiveTime: 'Effective Time',
    BeginDay: 'Begin Day',
    EndDay: 'End Day',
    OrgName: 'Org Name',
    OrgId: 'Org Id',
    RelationRule: 'Relation Rule',
    RuleCode: 'Rule Code',
    RuleName: 'Rule Name',
    ChooseUnit: 'Choose Unit',
    OnlineRegister: 'Online Register',
    Custom: 'Custom',
    SystemRetention: 'System Retention',
    UserNameCanNotBeEmpty: 'UserName Can Not Be Empty',
    UserCodeCanNotBeEmpty: 'User Code Can Not Be Empty',
    EffectiveTimeCanNotBeEmpty: 'Effective Time Can Not Be Empty',
    PleaseEnterNum: 'Please Enter Num',
    MobileCanNotBeEmpty: 'Mobile Can Not Be Empty',
    PleaseEnterCorrectMobile: 'Please Enter Correct Mobile',
    SystemCanNotBeEmpty: 'System Can Not Be Empty',
    BirthdayCanNotBeEmpty: 'Birthday Can Not Be Empty',
    ProvinceCanNotBeEmpty: 'Province Can Not Be Empty',
    CityCanNotBeEmpty: 'City Can Not Be Empty',
    AreaCanNotBeEmpty: 'Area Can Not Be Empty',
    LoginNameCanNotBeEmpty: 'LoginName Can Not Be Empty',
    PasswordCanNotBeEmpty: 'Password Can Not Be Empty',
    WechatNumberCanNotBeEmpty: 'WechatNumber Can Not Be Empty'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/base/user.js